import * as React from 'react'
import Menu from '@mui/material/Menu'
import { useState } from 'react'

// style
import { Drawer, IconButton, Typography } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
// import EditIcon from '@mui/icons-material/Edit'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
// import PersonRemoveIcon from '@mui/icons-material/PersonRemove'
import { Box } from '@mui/system'

import StepperEditUserOfOrganization from '../Modals/RightModals/EditUserOfOrganization'
import { UserSuscriberSeeMore } from '../../../../components/Modals/Subscriber/Users/RightModals/UserSuscriberSeeMore'
import useStylesModalMenuUserOfSuscriber from './Styles/useStyleModalMenuUserOfSuscriber'

export default function ModalMenuItemUserSuscriber ({
  item,
  setRows,
  setLoading,
  types,
  typesComercial,

  setOpenModalDisableUser
}) {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const [editUserOfOrganization, setEditUserOfOrganization] = useState(false)
  const [stateSeeMore, setstateSeeMore] = useState(false)

  const handleClickButton = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const classes = useStylesModalMenuUserOfSuscriber()
  const listEditUser = (anchor) => (
    <Box className={classes.stepperStyle} role="presentation">
      <StepperEditUserOfOrganization
        setEditUserOfOrganization={setEditUserOfOrganization}
        setLoading={setLoading}
        item={item}
        setRows={setRows}
        types={types}
        typesComercial={typesComercial}
      />
    </Box>
  )
  const listSeeMoreUser = (anchor) => (
    <Box className={classes.stepperStyleSeeMore} role="presentation">
      <UserSuscriberSeeMore
        style={{ marginTop: '5%' }}
        setLoading={setLoading}
        setstateSeeMore={setstateSeeMore}
        item={item}
        setRows={setRows}
      />
    </Box>
  )
  return (
    <>
      <MoreVertIcon
        sx={{
          color: '#026873',
          '&:hover': {
            color: '#00FFAC'
          }
        }}
        onClick={handleClickButton}
      />

      <Menu
        id="basic-menu"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <FiltersList
          item={item}
          onClose={handleClose}
          setstateSeeMore={setstateSeeMore}
          setEditUserOfOrganization={setEditUserOfOrganization}
          setOpenModalDisableUser={setOpenModalDisableUser}
        />
      </Menu>
      <Drawer anchor={'right'} open={editUserOfOrganization}>
        {listEditUser('right')}
      </Drawer>
      <Drawer anchor={'right'} open={stateSeeMore}>
        {listSeeMoreUser('right')}
      </Drawer>
    </>
  )
}

function FiltersList ({
  item,
  setLoading,
  onClose,
  setstateSeeMore,
  setEditUserOfOrganization,
  setOpenModalDisableUser
}) {
  const classes = useStylesModalMenuUserOfSuscriber()
  // const dispatch = useDispatch()

  // open modal disabled user
  // const handleOpenModalDisableUser = () => {
  //   dispatch(setUserOfSuscriberRequest())
  //   dispatch(setUserOfSuscriberSuccess(item))
  //   setOpenModalDisableUser(true)
  // }

  return (
    <Box
      sx={{
        width: 200
      }}
      className={classes.boxStyle}
      onClick={onClose}
    >
      <IconButton
        onClick={() => {
          onClose()
          setstateSeeMore(true)
        }}
      >
        <Box className={classes.boxTypography}>
          <ErrorOutlineOutlinedIcon className={classes.hoverButtonRotate} />
          <Typography className={classes.typographyStyle}>
            Ver detalles
          </Typography>
        </Box>
      </IconButton>

      {/* {isOrgTesting && userIsAdministrator() && (
        <>
          <IconButton
            onClick={() => {
              onClose()
              setEditUserOfOrganization(true)
            }}
          >
            <Box className={classes.boxTypography}>
              <EditIcon className={classes.hoverButton} />
              <Typography className={classes.typographyStyle}>
                Editar
              </Typography>
            </Box>
          </IconButton>

          <IconButton onClick={handleOpenModalDisableUser}>
            <Box className={classes.boxTypography}>
              <PersonRemoveIcon className={classes.hoverButton} />
              <Typography className={classes.typographyStyle}>
                Dar de baja
              </Typography>
            </Box>
          </IconButton>
        </>
      )} */}
    </Box>
  )
}
